import Chip from "@material-ui/core/Chip";
import React from "react";

export default function CustomChip(props) {

    return (
        <>
            <Chip
                label={props.label}
                disabled={props.disabled}
                onClick={(e) => { props.onClick(e) }} />
        </>
    )
}